import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { NgxPaginationModule } from 'ngx-pagination';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { saveAs } from 'file-saver';

import { AuthService } from '../../../services/auth.service';
import { UserService } from '../../../services/user.service';
import { ConfirmServiceService } from '../../confirm-dialog/confirm-service.service';
import { ProjectFilterService } from '../../../services/project-filter.service';

import { PaginatedProject } from '../../../models/paginated-project.model';
import { formatPhoneNumber } from '../../../helpers/phone-formatter';
@Component({
  selector: 'app-project-list',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, NgxPaginationModule],
  templateUrl: './project-list.component.html',
  styleUrl: './project-list.component.css',
})
export class ProjectListComponent implements OnInit {
  projects: Array<PaginatedProject> = new Array<PaginatedProject>();
  time_zone: String = Intl.DateTimeFormat().resolvedOptions().timeZone;

  filter: any = {
    page: 1,
    limit: 10,
    project_name: '',
    sort_column: 'created_on',
    sort_order: 'DESC',
    time_zone: this.time_zone,
  };

  totalRecords: number = 0;

  constructor(
    private authService: AuthService,
    private userService: UserService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private router: Router,
    private projFilterService: ProjectFilterService,
    private readonly confirmService: ConfirmServiceService
  ) {}
  ngOnInit(): void {
    this.spinner.show();
    this.getPaginatedProjects();
  }

  getPaginatedProjects(): void {
    this.userService.getPaginatedProjects(this.filter).subscribe(
      (response: any) => {
        this.projects = response.data?.projects ?? [];
        this.totalRecords = response.data?.total_projects ?? 0;
        this.spinner.hide();
      },
      (error: any) => {
        this.toastr.error(error.error.message.Text, `Project List`);
        this.spinner.hide();
        console.error(error.error.message);
      }
    );
  }

  pageChangeEvent(event: number) {
    this.spinner.show();
    this.filter.page = event;
    this.getPaginatedProjects();
  }
  searchByFilter(): void {
    this.spinner.show();
    this.getPaginatedProjects();
  }
  clearFilter(): void {
    this.spinner.show();
    this.filter.project_name = '';
    this.getPaginatedProjects();
  }

  confirmDelete(id: any) {
    const message = `Are you sure you want to delete the project?`;
    this.confirmService.showConfirm(
      message,
      () => {
        this.deleteProject(id);
      },
      () => {}
    );
  }

  deleteProject(id: any): void {
    this.spinner.show();
    this.userService.deleteProject({ project_id: id }).subscribe(
      (response: any) => {
        this.getPaginatedProjects();
        this.toastr.success(response.message.Text, `Project List`);
      },
      (error: any) => {
        this.toastr.error(error.error.message.Text, `Project List`);
        this.spinner.hide();
        console.error(error.error.message);
      }
    );
  }

  exportProject(): void {
    this.spinner.show();

    this.userService.exportProject(this.filter).subscribe(
      (data: Blob) => {
        const blob = new Blob([data], {
          //type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          type: 'application/octet-stream',
        });
        saveAs(blob, `projects_${new Date().getTime()}.xlsx`);
        this.toastr.success('Projects exported successfully', 'Project List');
        this.spinner.hide();
      },
      (error) => {
        console.error('Error downloading the file', error);
        this.spinner.hide();
      }
    );
  }

  sortProject(column: string) {
    if (this.filter.sort_column === column) {
      this.filter.sort_order =
        this.filter.sort_order === 'ASC' ? 'DESC' : 'ASC';
    } else {
      this.filter.sort_column = column;
      this.filter.sort_order = 'ASC';
    }
    this.getPaginatedProjects();
  }

  switchProject(project_id: any, name: any): void {
    this.spinner.show();
    this.setProjectBehaviorSubject(project_id, name);
    this.userService.addRecentProjectLogs({ project_id }).subscribe(
      (response: any) => {
        //this.toastr.success(response.message.Text, `Project List`);
        this.projFilterService.setFilter({ project_id, name });
        this.router.navigateByUrl('/home');
        this.spinner.hide();
      },
      (error: any) => {
        this.toastr.error(error.error.message.Text, `Project List`);
        this.spinner.hide();
        console.error(error.error.message);
      }
    );
  }

  setProjectBehaviorSubject(id: any, name: any) {
    let loggedUser = this.authService.CurrentUserValue;
    loggedUser.project_id = id;
    loggedUser.project_name = name;
    this.authService.setLoggedUserInfoToLocalStorage(loggedUser);
    //this.projFilterService.setFilter({ project_id: id, name: name });
  }

  formatContactNumber(phone: string): string {
    return formatPhoneNumber(phone);
  }
}
